module.exports = __webpack_public_path__ + "img/arrow-button-down-2.ea6efc6a.svg";